document.addEventListener('DOMContentLoaded', () => {
  const variantPicker = document.querySelector('.product-variant-picker-block');
  const storeLocator = document.querySelector('.buy-option--store-locator');
  const buyButtons = document.querySelector('.buy-option--atc');

  variantPicker.addEventListener("click", (event) => {
    if (event.target.tagName === "INPUT" && event.target.value === "Single Can") {
      buyButtons.style.display = "none";
      storeLocator.style.display = "block";
    } else if (event.target.tagName === "INPUT" && (event.target.value === "12 Pack" || event.target.value === "6 Pack")) {
      storeLocator.style.display = "none";
      buyButtons.style.display = "block";
    }
  });
});